<br><br>
<mat-nav-list>
  <div class="profile-card">
    <div class="header">
      <h3>Abdelkader</h3>
      <h4 style="color: grey">Finance Factory</h4>
    </div>
    <img src="assets/img/10.jpg" alt="Abdelkader BOUSABAA">
  </div>
</mat-nav-list>

<br>
<mat-divider></mat-divider>
<br>

<a class="dropdown-item" style="color: whitesmoke" routerLinkActive="active" routerLink="/home">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-home"></i>
    </div>
    <div class="col-10">
      <span>Home</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(118,168,255)" routerLinkActive="active" routerLink="/tools/dashboard">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-th-large"></i>
    </div>
    <div class="col-10">
      <span>Dashboard</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(118,168,255)" routerLinkActive="active" routerLink="/tools/my-portfolio">
  <div class="row">
    <div class="col-2">
      <i class="fab fa-elementor"></i>
    </div>
    <div class="col-10">
      <span>My Portfolio</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(118,168,255)" routerLinkActive="active" routerLink="/tools/analytics">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-chart-bar"></i>
    </div>
    <div class="col-10">
      <span>Analytics</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(118,168,255)" routerLinkActive="active" routerLink="/tools/strategy-builder">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-boxes"></i>
    </div>
    <div class="col-10">
      <span>Strategy Builder</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(118,168,255)" routerLinkActive="active" routerLink="/tools/strategy-customize">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-adjust"></i>
    </div>
    <div class="col-10">
      <span>Strategy Customize</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(118,168,255)" routerLinkActive="active" routerLink="/tools/investable-solution">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-magic"></i>
    </div>
    <div class="col-10">
      <span>Investable Solution</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(118,168,255)" routerLinkActive="active" routerLink="/tools/risk-management">
  <div class="row">
    <div class="col-2">
      <i class="fab fa-buffer"></i>
    </div>
    <div class="col-10">
      <span>Risk Management</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: rgb(118,168,255)" routerLinkActive="active" routerLink="/tools/position-keeping">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-hand-holding-usd"></i>
    </div>
    <div class="col-10">
      <span>Position Keeping</span>
    </div>
  </div>
</a>
<a class="dropdown-item" style="color: whitesmoke" routerLinkActive="active" (click)="onSignOut()">
  <div class="row">
    <div class="col-2">
      <i class="fas fa-sign-out-alt"></i>
    </div>
    <div class="col-10">
      <span>Sign out</span>
    </div>
  </div>
</a>

<!--
<br>
<mat-divider></mat-divider>
<br>

<div class="mx-5">
  <h3 class="card-text">Current Portfolio</h3>
  <p class="card-text">Returns</p>
  <div class="row card-text">
    <div class="col-6 card-text" style="color: rgb(227,143,72);"> Original </div>
    <div class="col-6"> <mdb-badge color="success-color">15.7%</mdb-badge> </div>
    <div class="col-6 card-text" style="color: rgb(129,186,241)"> Investable </div>
    <div class="col-6"> <mdb-badge color="success-color">16.8%</mdb-badge> </div>
    <div class="col-6 card-text" style="color: rgb(94,187,75)"> Protected </div>
    <div class="col-6"> <mdb-badge color="success-color">12.3%</mdb-badge> </div>
  </div>
  <br>
  <p class="card-text">Volatility</p>
  <div class="row card-text">
    <div class="col-6 card-text" style="color: rgb(227,143,72);"> Original </div>
    <div class="col-6"> <mdb-badge color="primary-color">12.7%</mdb-badge> </div>
    <div class="col-6 card-text" style="color: rgb(129,186,241)"> Investable </div>
    <div class="col-6"> <mdb-badge color="primary-color">13.1%</mdb-badge> </div>
    <div class="col-6 card-text" style="color: rgb(94,187,75)"> Protected </div>
    <div class="col-6"> <mdb-badge color="primary-color">10.3%</mdb-badge> </div>
  </div>
  <br>
  <p class="card-text">Market Exposure</p>
  <div class="row card-text">
    <div class="col-6 card-text" style="color: rgb(227,143,72);"> Original </div>
    <div class="col-6"> <mdb-badge color="primary-color">97.7%</mdb-badge> </div>
    <div class="col-6 card-text" style="color: rgb(129,186,241)"> Investable </div>
    <div class="col-6"> <mdb-badge color="primary-color">96.5%</mdb-badge> </div>
    <div class="col-6 card-text" style="color: rgb(94,187,75)"> Protected </div>
    <div class="col-6"> <mdb-badge color="primary-color">69.7%</mdb-badge> </div>
  </div>
  <br>
  <p class="card-text">Conditional Performance</p>
  <div class="row card-text">
    <div class="col-6 card-text" style="color: rgb(227,143,72);"> Original </div>
    <div class="col-6"> <mdb-badge color="success-color">7.8%</mdb-badge> </div>
    <div class="col-6 card-text" style="color: rgb(129,186,241)"> Investable </div>
    <div class="col-6"> <mdb-badge color="success-color">8.9%</mdb-badge> </div>
    <div class="col-6 card-text" style="color: rgb(94,187,75)"> Protected </div>
    <div class="col-6"> <mdb-badge color="success-color">6.7%</mdb-badge> </div>
  </div>
</div>
-->
